import { useEffect, useState } from "react";

const useSnackbarEffect = (isLoading: boolean, errorMessage?: string) => {
	const [snackbarOpen, setSnackbarOpen] = useState(false);

	const openSnackbar = () => setSnackbarOpen(true);
	const closeSnackbar = () => setSnackbarOpen(false);

	useEffect(() => {
		const isSuccessState = () => !isLoading && !errorMessage && snackbarOpen;
		const isLoadingState = () => isLoading && !errorMessage;
		const isErrorState = () => !!errorMessage;

		if (isLoadingState()) {
			openSnackbar();
		} else {
			const timer = setTimeout(() => {
				closeSnackbar();
			}, 5000);
			return () => clearTimeout(timer);
		}
	}, [isLoading, errorMessage, snackbarOpen]);

	return { snackbarOpen };
};

export default useSnackbarEffect;
